// Function definitions
const search = function(params = {}){
    return window.axios.get('/api/sites', {
        params: params,
    });
};

const get = function(id){
    return window.axios.get('/api/sites/'+id);
};

const create = function(site){
    return window.axios.post('/api/sites', site);
};

const update = function(site){
    return window.axios.put('/api/sites/'+site.id, site);
};

const updateReminder = function(site){
    return window.axios.put('/api/sites/'+site.id + '/reminder', site);
};

const deleteSite = function(site){
    return window.axios.delete('/api/sites/'+site.id, site);
};

const updateOrCreate = function(site) {
    if(site.id) {
        return update(site);
    } else {
        return create(site);
    }
};

const updateProducts = function(siteId, products) {
    return window.axios.put('/api/sites/' + siteId + '/products', {products});
};

const engineerNotes = function(siteId) {
    return window.axios.get('/api/sites/'+siteId+'/engineer-notes');
};

const storeEngineerNotes = function(siteId ,engineerNotes) {
    return window.axios.put('/api/sites/'+siteId+'/engineer-notes', {engineer_notes: engineerNotes});
};

export default {
    search,
    get,
    create,
    update,
    updateReminder,
    delete: deleteSite,
    updateOrCreate,
    updateProducts,
    engineerNotes,
    storeEngineerNotes,
}


// WEBPACK FOOTER //
// ./resources/assets/js/services/SitesService.js